// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import * as types from './actionTypes';

export function requestOrderDetails(data) {
  return {
    type: types.ORDER_REQUEST,
    data,
  };
}
export function orderRequestSuccess(response) {
  return {
    type: types.ORDER_REQUEST_SUCCESS,
    response
  };
}
export function orderRequestFailed(error) {
  return {
    type: types.ORDER_REQUEST_FAILED,
    error
  };
}

export function resetOrder() {
  return {
    type: types.ORDER_RESET,
  };
}
